import { useHistory } from "react-router-dom";
import { Translator } from "../services/TranslationService";


export function NotFound(props: {
    translator: Translator,
}) {

    const history = useHistory();

    return (
        <div className="not-found">
            <h1> {props.translator("notFound header", "Siden blev ikke fundet")}</h1>

            <button className="btn btn-primary" onClick={() => history.goBack()} >
                {props.translator("notFound backButton", "Tilbage")}
            </button>
        </div>
    );
}
